import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

import { useRoutesUiStore } from "@/components/RoutesProvider";

import { useModal } from "../../../components/modals/useModal";
import { useRoutesUiContext } from "../../../components/RoutesProvider/RoutesProvider";

const CreateRoute = () => {
  const { routes, onAddRoute } = useRoutesUiContext();
  const routeFormIsDirty = useRoutesUiStore((state) => state.routeFormIsDirty);

  const params = Route.useParams();
  const search = Route.useSearch();

  const navigate = Route.useNavigate();

  const hasRunRef = useRef(false);
  const { display: displayModal } = useModal();

  useEffect(() => {
    if (!routes) {
      return;
    }
    if (hasRunRef.current) {
      return;
    }
    if (!hasRunRef.current) {
      hasRunRef.current = true;
    }
    if (routeFormIsDirty) {
      displayModal("UNSAVED_ROUTE_CHANGES_PROMPT");
    } else {
      onAddRoute();
    }
    navigate({
      from: Route.fullPath,
      to: "..",
      params,
      search,
    });
  }, [routes, routeFormIsDirty, displayModal, navigate, onAddRoute, params, search]);

  return null;
};

export const Route = createFileRoute("/gym/$venueUuid/routes/$climbType/create")({
  component: CreateRoute,
});
